import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Button';

const CreditCardFrameContainer = styled.div`
	width: 30em;
	min-height: 20em;
	margin: auto;
	margin-top: 4em;
	iframe {
		min-height: 400px;
		min-width: 400px;
	}
`;

const SuccessMessage = styled.div`
	margin: auto;
	text-align: center;
`;

const CreditCardInfoPageContent = (props) => (
	<div>
		{!props.creditCardSubmitFinished && !props.setDefaultPaymentMethodFinished && (
			<div>
				<CreditCardFrameContainer id={'zuora_payment'} />
			</div>
		)}
		{props.creditCardSubmitFinished && props.setDefaultPaymentMethodFinished && (
			<SuccessMessage>
				<h4>Maksukortin päivitys onnistui</h4>
				<Link to={'/account/customerInfo'}>
					<Button>Takaisin asiakastietoihin</Button>
				</Link>
			</SuccessMessage>
		)}
	</div>
);

CreditCardInfoPageContent.propTypes = {
	creditCardSubmitFinished: PropTypes.bool,
	setDefaultPaymentMethodFinished: PropTypes.bool
};

export default CreditCardInfoPageContent;
